export default function checkScriptHomeTimer(script: string | undefined) {
  const regex = /PLAYER\.config\.homeTimer\s*=\s*\d+/;

  if (script === undefined) {
    return false;
  }

  const result = regex.test(script);

  return result;
}
